/**************************************************
 * Nombre:       Formulario_Cupones
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {
    AccountCircleOutlined,
    FlagOutlined,
    Google,
    PercentOutlined,
    PhoneAndroid,
    QrCodeOutlined
} from "@mui/icons-material";
import IngresoSelectFalsoVerdadero from "../../Modulo_formularios/Componentes/IngresoSelectFalsoVerdadero";

const Formulario_Cupones = ({...props}) => {

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >

                <Grid container size={6} sx={{justifyContent: 'flex-start'}}>
                    <IngresoSelectFalsoVerdadero Icono={FlagOutlined} nombre={'Cangeado'} dato={'cangeado'} {...props}
                                                 requerido={'El Nombre es requerido'}
                    />
                </Grid>

                <Grid container size={6} sx={{justifyContent: 'flex-start'}}>
                    <IngresoTexto Icono={PercentOutlined} nombre={'Porcentaje'} dato={'porcentaje'} {...props}
                                  requerido={'El Nombre es requerido'} type={'number'}
                    />
                </Grid>

                <Grid container size={6} sx={{justifyContent: 'flex-start'}}>
                    <IngresoTexto Icono={QrCodeOutlined} nombre={'Codigo'} dato={'codigo'} {...props}
                                  requerido={'El Nombre es requerido'}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={AccountCircleOutlined} nombre={'Nombre'} dato={'nombre'} {...props}

                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={PhoneAndroid} nombre={'Celular'} dato={'celular'} {...props}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={Google} nombre={'Correo de Google'} dato={'correo'} {...props}
                    />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Cupones